import React from 'react';
import './BFFilterBar.css';

export interface BFFilterBarProps {
    activeCount?: number;
    matchCount?: number;
    matchLabel?: string;
    onReset?: () => void;
    children?: React.ReactNode;
    className?: string;
}

export function BFFilterBar({
    activeCount,
    matchCount,
    matchLabel = 'List Of Matches',
    onReset,
    children,
    className = '',
}: BFFilterBarProps) {
    return (
        <div className={`bf-filter-bar ${className}`}>
            <div className="bf-filter-bar__left">
                <div className="bf-filter-bar__summary">
                    <span className="bf-filter-bar__icon" aria-hidden="true">
                        {/* funnel icon */}
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1 2h12l-4.5 5.5V12L5.5 10.5V7.5L1 2z"
                                stroke="currentColor"
                                strokeWidth="1.2"
                                strokeLinejoin="round"
                                fill="none"
                            />
                        </svg>
                    </span>
                    <span className="bf-filter-bar__label">Filters</span>
                    {activeCount !== undefined && activeCount > 0 && (
                        <span className="bf-filter-bar__active-badge">{activeCount} active</span>
                    )}
                    {onReset && activeCount !== undefined && activeCount > 0 && (
                        <button type="button" className="bf-filter-bar__reset" onClick={onReset}>
                            reset
                        </button>
                    )}
                </div>
                {matchCount !== undefined && (
                    <div className="bf-filter-bar__match-count">
                        <span className="bf-filter-bar__match-number">{matchCount.toLocaleString()}</span>
                        <span className="bf-filter-bar__match-label">{matchLabel}</span>
                    </div>
                )}
            </div>
            {children && <div className="bf-filter-bar__controls">{children}</div>}
        </div>
    );
}
